export function getGoogleMapsLink(latitude: number | string, longitude: number | string): string {
  return encodeURI(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`)
}
